import { Text, View } from '@react-pdf/renderer';

// Components
import { PDFRichText } from '@/components/PDFRichText';

// Tokens
import { SECTION_TITLES } from '@/components/template/resume/Default/tokens';

// Styles
import styles from '../../style';
interface BioSectionProps {
  bio: string;
}
const BioSection = ({
  bio
}: BioSectionProps) => {
  if (!bio) return null;
  return <View style={styles.contentSection} data-sentry-element="View" data-sentry-component="BioSection" data-sentry-source-file="Bio.tsx">
      <Text style={styles.contentSectionTitle} data-sentry-element="Text" data-sentry-source-file="Bio.tsx">{SECTION_TITLES.bio}</Text>
      <View style={styles.paragraph} data-sentry-element="View" data-sentry-source-file="Bio.tsx">
        <PDFRichText html={bio} data-sentry-element="PDFRichText" data-sentry-source-file="Bio.tsx" />
      </View>
    </View>;
};
export default BioSection;